import { CompanyRole } from 'constants/CompanyRole';
import localStorageService from 'services/local-storage-service';
import { useAppSelector } from 'store';
import { profileSelector } from 'store/selectors/profile-selectors';

/**
 * Only a SuperAdmin that is not impersonating may write MfaRequiredOverride. Every other caller -
 * including a SuperAdmin inside an impersonation session - gets a 403 that fails the entire save,
 * and the rejection is recorded server-side as a security event. So the control is not rendered at
 * all for anyone else, and the field is kept out of the payload rather than sent and refused.
 */
const useCanWriteMfaOverride = (): boolean => {
  const role = useAppSelector(profileSelector)?.role;
  const isImpersonated = localStorageService.getItem<boolean>('isImpersonated');

  return role === CompanyRole.ADMIN && !isImpersonated;
};

export default useCanWriteMfaOverride;
